import http from '@/utils/http';

// 搜索 国家/地区
export const searchSeason = (params) => {
    return http.request({
        url: "/v1/olympics/season/search",
        method: 'post',
        data: params,
    })
}